import { render, staticRenderFns } from "./RootProfileDropdown.vue?vue&type=template&id=0e963568&scoped=true&"
import script from "./RootProfileDropdown.vue?vue&type=script&lang=js&"
export * from "./RootProfileDropdown.vue?vue&type=script&lang=js&"
import style0 from "./RootProfileDropdown.vue?vue&type=style&index=0&id=0e963568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e963568",
  null
  
)

export default component.exports